let loadRouterPath = [];
if (process.env.REACT_APP_WELINK_ENV === 'redBlue') {
  loadRouterPath = [
    require.context('./weForm', true, /route.js$/),
    require.context('./form-resources', true, /route.js$/),
    require.context('./weVote', true, /route.js$/),
    require.context('./Statistic', true, /route.js$/),
    require.context('./routes-redBlue/home', true, /route.js$/),
    require.context('./routes-redBlue/credentials-info', true, /route.js$/),
    require.context('./routes-redBlue/api-manage', true, /route.js$/),
    require.context('./routes-redBlue/add-ability', true, /route.js$/),
    require.context('./routes-redBlue/member-manage', true, /route.js$/),
    require.context('./routes-redBlue/version', true, /route.js$/),
    require.context('./routes-redBlue/version-detail', true, /route.js$/),
    require.context('./routes-redBlue/approve-manage', true, /route.js$/),
    require.context('./routes-redBlue/capability-manage', true, /route.js$/),
    require.context('./routes-redBlue/complaint-manage', true, /route.js$/),
    require.context('./routes-redBlue/complaint-detail', true, /route.js$/),
    require.context('./routes-redBlue/event-callback', true, /route.js$/),
    require.context('./routes-redBlue/no-permission', true, /route.js$/),
    require.context('./routes-redBlue/app-capabilities-manage', true, /route.js$/),
    require.context('./routes-redBlue/entry-group-notification', true, /route.js$/),
    require.context('./routes-redBlue/project-configuration', true, /route.js$/),
    require.context('./routes-redBlue/operation-management', true, /route.js$/),
  ]
} else {
  loadRouterPath = [
    require.context('./', true, /route.js$/),
    require.context('./new-router', true, /route.js$/)
  ]
}
export default loadRouterPath;



